// Analytics orchestrator.
//
// Single entry point for "wake up analytics if the user has granted consent".
// Subscribes to consent changes so a fresh Accept loads scripts immediately,
// without a page reload. Feature code calls `initAnalytics()` once on boot.

import { consent, type ConsentStatus } from '../consent'
import { loadGtm } from './gtm'
import { loadGa4 } from './ga'

let unsubscribe: (() => void) | null = null

function applyStatus(status: ConsentStatus): void {
  if (status !== 'granted') return
  loadGtm()
  loadGa4()
}

export function initAnalytics(): void {
  applyStatus(consent.get())
  unsubscribe?.()
  unsubscribe = consent.subscribe(applyStatus)
}

export function _teardownAnalyticsForTesting(): void {
  unsubscribe?.()
  unsubscribe = null
}
